/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react';
import Footer from './Footer';
import AddTodo from './AddTodo';
//import UndoRedo from './UndoRedo';
import VisibleTodoList from './VisibleTodoList';

const Todos = () => (
  <div>
    <VisibleTodoList />
    <AddTodo />
    <Footer />
  </div>
);

export default Todos;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/todos/index.js